module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/main-visual-f44f3ed5315a4f912bfab13f75e5e740.jpg";